// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Paste your config object here
const firebaseConfig = {
  apiKey: "AIzaSyC5qBa_30sFqDBuK8vOKy03ll0_z9TQur4",
  authDomain: "korlish.firebaseapp.com",
  projectId: "korlish",
  storageBucket: "korlish.firebasestorage.app",
  messagingSenderId: "997749972656",
  appId: "1:997749972656:web:e279bcb9349bf9118a2575",
  measurementId: "G-ZP223YQRBE"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);